/** Non-secret hint that a B-01B httpOnly cookie session may exist (cookies are not readable from JS). */
export const COOKIE_SESSION_KEY = 'cookieSessionActive';

export function markCookieSessionActive() {
  localStorage.setItem(COOKIE_SESSION_KEY, '1');
}

export function clearCookieSessionHint() {
  localStorage.removeItem(COOKIE_SESSION_KEY);
}

export function hasCookieSessionHint() {
  return localStorage.getItem(COOKIE_SESSION_KEY) === '1';
}
